<template>

<v-container fluid>
  <v-row>
      <v-col cols="12">
          <div class="d-flex justify-center">
             <v-subheader class="headline font-weight-bold ">Trainer Led Live Trainings</v-subheader>
          </div>
        </v-col>
        <v-col v-if="modules.TrainingByTrainerList" cols="12" sm="6" md="6" lg="4" class="justify-center">
        <router-link :to="{ name: 'AllTrainings' }">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
            color="orange" cardTitle="All Trainings"> </clickable-card>
        </router-link>

      </v-col>

      <v-col v-if="modules.TrainingByTrainerReports" cols="12" sm="6" md="6" lg="4" class="justify-center">
           <router-link :to="{ name: 'allTrainerFeedbackReport' }">
              <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-file-document-edit-outline"
               color="orange" cardTitle="Trainer Reports"> </clickable-card>
           </router-link>
      </v-col>
  </v-row>
</v-container>
</template>

<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'

export default {

  name: 'TeacherLedTraining',
  components: { ClickableCard },
  data () {
    return {
      modules: {
        TrainingByTrainerList: this.checkModuleAccess('TrainingByTrainerList'),
        TrainingByTrainerReports: this.checkModuleAccess('TrainingByTrainerReports')
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  },
  async created () {
    console.log(this.modules)
  }

}
</script>
